import React, { PropsWithChildren } from 'react';

type EnterpriseScreenProps = {};

export const EnterpriseScreen = ({
  children,
}: PropsWithChildren<EnterpriseScreenProps>) => {
  return <>{children}</>;
};
